type ValidationWhen = Record<string, unknown>;

export const getAsciiTextValidation = (when?: ValidationWhen) => ({
  regex: {
    value: '^[\\x20-\\x7E\\r\\n]+$',
    ...(when && { when }),
    message: 'Only English letters (A–Z), numbers, and symbols are allowed',
  },
});

export const asciiTextValidation = getAsciiTextValidation();

export const digitSymbolValidation = {
  regex: {
    value: '^[0-9\\x21-\\x2F\\x3A-\\x40\\x5B-\\x60\\x7B-\\x7E]+$',
    message: 'Only numbers and symbols are allowed',
  },
};
